import { Reveal, Eyebrow } from "@/components/Reveal";
import { TREATMENT_ICONS } from "@/components/icons";
import { TREATMENTS } from "@/data/clinic";

const TreatmentCard = ({ t, index }) => {
  const Icon = TREATMENT_ICONS[t.icon];
  const dark = index === 4;
  return (
    <Reveal delay={(index % 3) * 0.1} className="h-full">
      <article
        data-testid={`treatment-card-${t.icon}`}
        className={
          dark
            ? "group h-full overflow-hidden rounded-2xl border border-transparent bg-[#0F574E] shadow-[0_8px_30px_rgba(6,58,47,0.14)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl"
            : "group h-full overflow-hidden rounded-2xl border border-[#063A2F]/10 bg-white shadow-[0_8px_30px_rgba(6,58,47,0.05)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
        }
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={t.img}
            alt={t.alt}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-[#FDFCF8]/95 text-[#0D9488] shadow">
            <Icon className="h-5 w-5" />
          </span>
          <span className="font-display absolute right-4 top-4 rounded-full bg-[#063A2F]/70 px-2.5 py-0.5 text-sm text-[#D4AF37]">
            {String(index + 1).padStart(2, "0")}
          </span>
        </div>
        <div className="p-6">
          <h3 className={`text-base font-bold ${dark ? "text-[#FDFCF8]" : "text-[#063A2F]"}`}>
            {t.name}
          </h3>
          <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-[#F2FBF7]/75" : "text-[#475569]"}`}>
            {t.desc}
          </p>
        </div>
      </article>
    </Reveal>
  );
};

export const Treatments = () => (
  <section id="treatments" data-testid="treatments-section" className="bg-[#FDFCF8] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="max-w-2xl">
        <Eyebrow>Treatments &amp; Services</Eyebrow>
        <h2 className="font-display mt-5 text-4xl tracking-tight text-[#063A2F] sm:text-5xl">
          Complete dental care, <span className="italic text-[#0D9488]">under one roof</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-[#475569]">
          From routine cleaning to full-mouth rehabilitation, our treatments cover
          every stage of your family's dental health.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {TREATMENTS.map((t, i) => (
          <TreatmentCard key={t.icon} t={t} index={i} />
        ))}
      </div>
    </div>
  </section>
);
